var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSectionEnterprise3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M26.8325 15.7586L24.7209 8.86115C23.9569 -3.04858 57.892 -2.69421 56.1492 8.36786L54.7114 16.4986L60.7095 11.3247C73.336 3.95097 86.0759 34.7586 76.8449 37.1145L69.3276 38.4271L76.0838 43.0283C85.4949 48.599 72.1364 75.3526 61.8859 69.3652L55.4347 63.7888L55.5538 72.5006C55.5508 82.9362 24.1893 81.9043 25.6852 72.9656L26.6408 63.6725L20.0705 69.5976C9.1432 75.8431 -5.09832 45.2821 5.49495 42.1863L12.3035 39.8616L4.7775 37.8884C-7.61665 34.9939 6.40411 3.58526 20.6689 10.8229L26.8325 15.7586Z",
    fill: "#D7D3F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSectionEnterprise3);
export default __webpack_public_path__ + "static/media/icon-section-enterprise-3.59bc8702300c250f32c3dbaf5ca2bb5ef2a904ecbc2502fb3e083c4c5ddbf140.svg";
export { ForwardRef as ReactComponent };